import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { editProfile } from '../../../shared/constants';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { ProfileService } from '../profile.service';
import { User, UserDetail } from '../profile.model';
import { SessionStateService } from '../../../core/services/session-state.service';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { DeleteUserDialogComponent } from '../delete-user-dialog/delete-user-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';
import { Constants } from '../../../core/services/constants';

@Component({
  selector: 'app-edit-profile-tab',
  templateUrl: './edit-profile-tab.component.html',
  styleUrls: ['./edit-profile-tab.component.scss']
})
export class EditProfileTabComponent implements OnInit {
  haveAdminPermissions;
  loading = false;
  isAdmin = false;
  editProfile = editProfile;
  profileForm: FormGroup;
  profileFormPassword: FormGroup;
  @Input() defaultTab: string;
  @Input() user: User;
  userDetail: UserDetail;
  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  tab: string;

  seeNewPassword = false;
  seeConfPassword = false;
  isLoggedProfile = false;
  languages: Array<[string, string]> = [['PT', 'Portuguese'], ['ES', 'Spanish'], ['EN', 'English']];
  /** House Permissions */
  montlyReports: number;
  receiveNotifications: number;
  receiveEmail: number;
  deleteDialogRef: MatDialogRef<DeleteUserDialogComponent>;

  statusMessage: string;
  oldPasswordInputError = false;
  newPasswordInputError = false;
  dirtyForm: boolean;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private sessionStateService: SessionStateService,
    private athenticationService: AuthenticationService,
    private dialog: MatDialog) { }

  ngOnInit() {
    // console.log(this.user);
    this.tab = this.defaultTab;
    this.route.queryParams.subscribe(values => {
      if (Object.keys(editProfile).map(k => k.split('_').join(' ')).includes(values.profileEditType)) {
          this.tab = values.profileEditType;
          this.change.emit(values.profileEditType !== undefined);
      }
    });
    this.loading = true;
    this.loadUserDetail();
    this.loadUserPermissions();
    this.profileForm = new FormGroup({
      firstName: new FormControl(this.user.firstName, Validators.nullValidator && Validators.required),
      lastName: new FormControl(this.user.lastName, Validators.nullValidator && Validators.required),
      email: new FormControl(this.user.email, Validators.nullValidator && Validators.required),
      oldPassword: new FormControl('', Validators.nullValidator && Validators.required),
      newPassword: new FormControl('', Validators.nullValidator && Validators.required),
      confirmPassword: new FormControl('', Validators.nullValidator && Validators.required),
    });
    this.profileFormPassword = new FormGroup({
      oldPassword: new FormControl('', Validators.nullValidator && Validators.required),
      newPassword: new FormControl('', Validators.nullValidator && Validators.required),
      confirmPassword: new FormControl('', Validators.nullValidator && Validators.required),
    });
  }

  loadUserDetail() {
    this.profileService.getUser()
      .finally(() => {
        this.haveAdminPermissions = this.user.permissionRole === 'Admin';
        if (this.userDetail.email === this.user.email) {
          this.isLoggedProfile = true;
          this.isAdmin = this.user.permissionRole === 'Admin';
        } else {
          this.isAdmin = false;
          this.isLoggedProfile = false;
        }
        this.loading = false;
      }).subscribe(userDetail => {
        this.userDetail = userDetail;
      });
  }

  loadUserPermissions() {
    this.montlyReports = this.user.receiveReport;
    this.receiveNotifications = this.user.receivePush;
    this.receiveEmail = this.user.receiveEmail;
  }

  changeLanguage(event) {
    this.dirtyForm = true;
    this.userDetail.languageCode = event;
  }

  onSave(form: NgForm) {
    this.profileService.editUser(form.value.firstName, form.value.lastName, this.userDetail.languageCode).subscribe(res => {
      this.onCloseDialog();
    }, (err => {
      // console.log(err);
    })
    );
  }

  onSavePassword(form: NgForm) {
    this.statusMessage = '';
    this.oldPasswordInputError = false;
    this.newPasswordInputError = false;
    if (form.value.oldPassword !== '' && form.value.newPassword !== '' && this.isLoggedProfile) {
      if (form.value.newPassword === form.value.confirmPassword) {
        if (!(Constants.REGEX.PASSWORD_REGEX.test(form.value.newPassword))) {
          this.statusMessage = Constants.MSG.PWD_RESTRICTIONS;
          this.newPasswordInputError = true;
        } else {
          this.athenticationService.changePassword(this.user.email, form.value.oldPassword, form.value.newPassword).subscribe(res => {
            this.onCloseDialog();
          }, err => {
            this.oldPasswordInputError = true;
            this.statusMessage = err.message;
          });
        }
      } else {
        this.newPasswordInputError = true;
        this.statusMessage = Constants.MSG.PWDS_DONT_MATCH;
      }
    } else {
      this.oldPasswordInputError = true;
      this.statusMessage = Constants.MSG.GENERAL_ERROR;
    }
  }

  onCloseDialog() {
    this.router.navigate(['/profile']);
    this.close.emit(true);
  }

  getUserPermissionRole(): string {
    if (this.user.permissionRole === 'Admin') {
      return 'Administrator';
    } else {
      return 'User';
    }
  }

  getHouseName() {
    return this.sessionStateService.getHouse().name;
  }

  savePermissions() {
    this.profileService.editUserAccess(
      this.montlyReports  === 1 ? true : false,
      this.receiveEmail === 1 ? true : false,
      this.receiveNotifications  === 1 ? true : false)
    .subscribe( response => {
    });
    this.onCloseDialog();
  }

  deleteUser() {
    this.deleteDialogRef = this.dialog.open(DeleteUserDialogComponent, {
      data: {
        email: this.user.email
      },
      autoFocus: false,
      panelClass: 'deleteUserPopup'
    });
    const sub = this.deleteDialogRef.componentInstance.action
      .subscribe((response: boolean) => {
        if (response) {
          this.loading = true;
          return this.profileService.removeUser(this.user.email).subscribe(res => {
            this.loading = false;
            this.onCloseDialog();
          });
        }
      });
  }

  dirtyBtn() {
    this.dirtyForm = true;
  }

  toggleMontlyReports() {
    if (this.isLoggedProfile) {
      this.montlyReports = this.montlyReports === 0 ? 1 : 0;
      this.dirtyBtn();
    }
  }

  toggleNotifications() {
    if (this.isLoggedProfile) {
      this.receiveNotifications = this.receiveNotifications === 0 ? 1 : 0;
      this.dirtyBtn();
    }
  }

  toggleEmails() {
    if (this.isLoggedProfile) {
      this.receiveEmail = this.receiveEmail === 0 ? 1 : 0;
      this.dirtyBtn();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/profile/edit-profile-tab/edit-profile-tab.component.ts